import { connectHits } from 'react-instantsearch-dom';
import Image from 'components/shared/image';
import SiteLink from 'components/shared/sitelink';
import useIsMobile from 'hooks/utils/useIsMobile';
import useSearchContentTracking from 'hooks/tracking/useSearchContentTracking';
import { useRouter } from 'next/router';
import { addLocaleToHref } from 'lib/utils/helpers';
import styles from './articleHits.module.scss';

const ArticleHits = ({ locale, hits, hasResults, noSearchDone, searchQuery, resources }) => {
  const isMobile = useIsMobile();
  const { inspirationTitle, noArticles } = resources[3];
  const router = useRouter();

  const trackSearchResultClick = slug =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useSearchContentTracking({
      searchQuery,
      searchResult: {
        type: 'article',
        slug,
      },
      location: { action: router },
    });

  const blogArticles = hits
    .filter(
      hit =>
        hit.sectionsCollection.length > 0 &&
        hit.sectionsCollection.some(
          // eslint-disable-next-line no-underscore-dangle
          section => section.__typename === 'SectionBlogArticle' && section.title
        )
    )
    .map(hit => {
      const blogArticle = hit.sectionsCollection.find(
        // eslint-disable-next-line no-underscore-dangle
        section => section.__typename === 'SectionBlogArticle'
      );
      return {
        title: blogArticle.title,
        articleType: blogArticle.category,
        headlineImage: blogArticle.headlineImage,
        slug: hit.slug,
      };
    });
  const maximumBlogArticles =
    blogArticles.length >= 2 ? blogArticles.slice(0, 2) : blogArticles.slice(0, 1);
  const hasBlogArticles = maximumBlogArticles?.length > 0;

  return (
    <div className={styles.searchPageArticlesWrapper}>
      {!noSearchDone && (
        <>
          <h2 className={styles.informationTitle}>{inspirationTitle.text}</h2>
          {!hasBlogArticles && <p className={styles.noArticlesText}>{noArticles.text}</p>}
          {hasResults &&
            maximumBlogArticles.map(article => (
              <SiteLink
                locale={locale}
                key={article.slug}
                onClick={() => trackSearchResultClick(article.slug)}
                className={styles.searchPageArticleCardWrapper}
                href={addLocaleToHref(article.slug, locale, router)}
              >
                {article.headlineImage && (
                  <div className={styles.searchPageArticleHighlightImage}>
                    <Image
                      src={
                        isMobile
                          ? article.headlineImage.imageMobile
                          : article.headlineImage.imageDesktop
                      }
                      layout="fill"
                      loading="lazy"
                      sizes="(max-width: 899px) 50vw, 20vw"
                    />
                  </div>
                )}

                <div className={styles.searchPageArticleInfo}>
                  <h2 className={styles.searchPageArticleCategory}>{article.articleType}</h2>
                  <h3 className={styles.searchPageArticleTitle}>{article.title}</h3>
                </div>
              </SiteLink>
            ))}
        </>
      )}
    </div>
  );
};

const CustomArticleHits = connectHits(ArticleHits);

export default CustomArticleHits;
